<div class="block">
  <table class="tbl">
    <thead>
    <tr>
      <th>Name</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let attendee of attendeeService.get(limit, offset)">
      <td>{{ attendee.name }}</td>
    </tr>
    </tbody>
  </table>
</div>
